module.exports = __webpack_public_path__ + "static/nestle-c6c095b571d293c68ac58718a84af1fe.png";